const moduleMap = {
	"./Datahub": () => {
		return Promise.all([__webpack_require__.e(2248), __webpack_require__.e(6507), __webpack_require__.e(8928), __webpack_require__.e(9667), __webpack_require__.e(595), __webpack_require__.e(5620), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(1185), __webpack_require__.e(3241), __webpack_require__.e(9939), __webpack_require__.e(9978), __webpack_require__.e(4191)]).then(() => (() => ((__webpack_require__(82497)))));
	},
	"./Drawer": () => {
		return Promise.all([__webpack_require__.e(2248), __webpack_require__.e(8928), __webpack_require__.e(4914), __webpack_require__.e(3241), __webpack_require__.e(5907)]).then(() => (() => ((__webpack_require__(95907)))));
	},
	"./Layout": () => {
		return Promise.all([__webpack_require__.e(2248), __webpack_require__.e(6507), __webpack_require__.e(8928), __webpack_require__.e(9667), __webpack_require__.e(595), __webpack_require__.e(5620), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(1185), __webpack_require__.e(3241), __webpack_require__.e(9939), __webpack_require__.e(9978), __webpack_require__.e(2399)]).then(() => (() => ((__webpack_require__(72620)))));
	},
	"./AppRoutes": () => {
		return Promise.all([__webpack_require__.e(2248), __webpack_require__.e(6507), __webpack_require__.e(8928), __webpack_require__.e(9667), __webpack_require__.e(595), __webpack_require__.e(5620), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(1185), __webpack_require__.e(3241), __webpack_require__.e(9939), __webpack_require__.e(9978), __webpack_require__.e(6177)]).then(() => (() => ((__webpack_require__(4259)))));
	},
	"./DataRepoRouter": () => {
		return Promise.all([__webpack_require__.e(2248), __webpack_require__.e(6507), __webpack_require__.e(8928), __webpack_require__.e(9667), __webpack_require__.e(595), __webpack_require__.e(5620), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(1185), __webpack_require__.e(3241), __webpack_require__.e(9978), __webpack_require__.e(4640)]).then(() => (() => ((__webpack_require__(41192)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});